// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://esvhlvsfyrovwvkskfua.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVzdmhsdnNmeXJvdnd2a3NrZnVhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ1MzIwNTYsImV4cCI6MjA1MDEwODA1Nn0.6SHIRmefOL8ERK75BwWIx4YgldNpQc6UgjORZ3mURz0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});